module.exports = __webpack_public_path__ + "img/searchBible.d1782112.png";